import {Record} from "immutable";
import {ApplicationState} from "../../reducer";
import {BoardModel} from "../model";
import {ElementsTree} from "../model/ElementsTree";

const getElementsTreeByBoardId = (state: Record<ApplicationState>, boardId: BoardModel.BoardId): ElementsTree => state.getIn(['inspectioBoards', 'elementsTree', boardId]) || new ElementsTree();

export const makeElementsTreeByBoardIdSelector = (boardId: BoardModel.BoardId): (state: Record<ApplicationState>) => ElementsTree => (state: Record<ApplicationState>) => getElementsTreeByBoardId(state, boardId);